import React from 'react';

const IframeModal = ({ isOpen, title, iframeTitle, src, heightClassName = 'h-[85vh]', onClose, footer }) => {
  if (!isOpen || !src) return null;

  return (
    <div className="fixed inset-0 z-[10000] flex items-center justify-center p-4 md:p-6">
      <div className="absolute inset-0 bg-black/40 backdrop-blur-sm" onClick={onClose} />

      <div className={`relative w-full max-w-5xl ${heightClassName} bg-card rounded-xl border border-border shadow-elevation-3 overflow-hidden flex flex-col`}>
        <div className="flex items-center justify-between px-4 py-3 border-b border-border shrink-0">
          <p className="text-sm font-semibold text-foreground">{title}</p>
          <button type="button" className="text-sm text-muted-foreground hover:text-foreground" onClick={onClose}>
            닫기
          </button>
        </div>

        <div className="flex-1 min-h-0">
          <iframe title={iframeTitle} src={src} className="w-full h-full" />
        </div>

        {footer}
      </div>
    </div>
  );
};

export default IframeModal;
